import styled from 'styled-components';
import { slideInLeft } from 'Styles/effects';
import { WrapperToolParams } from 'Screens/Automation/Schedule/components/CreateEditSchedule/styled';

export const Wrapper = styled.div.attrs(({ wrapperWidth }) => {
  let width = '55%';
  if (wrapperWidth) width = `${wrapperWidth}px`;
  return ({ style: { width } });
})`
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
  overflow-x: hidden;
  position: absolute;
  right: 0;
  top: 50px;
  z-index: 1;
  box-shadow: -5px 0 12px 0 rgba(35, 35, 35, 0.11);
  height: calc(100% - 63px);
  ${slideInLeft};
`;
Wrapper.displayName = 'Wrapper';

export const DetailWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  padding: 20px 0 0 4px;
  background-color: ${({ theme }) => theme.backgrounds.detailModal};
  height: 100%;
  width: 97%;
  position: relative;
`;
DetailWrapper.displayName = 'DetailWrapper';

export const Content = styled.div`
  overflow-y: auto;
  padding-bottom: 20px;
  padding-right: 15px;
  & > * {
    margin-bottom: 20px;
  }
  & > :last-child {
    margin-bottom: 0;
    margin-left: 16px;
  }
  & > :nth-child(4) {
    margin-left: 16px;
  }
`;
Content.displayName = 'Content';

export const StyledToolParams = styled(WrapperToolParams)`
  margin: 16px;
`;
StyledToolParams.displayName = 'StyledToolParams';
